import { t } from "../hooks/translations"
import css from "../style.module.scss"
import appStore from "../../app-store/static/ios.svg"
import playStore from "../../app-store/static/google-play.svg"
import appMockup from "../static/app-mockup.png"
import { Check } from "../icons/check"

export const SuccessScreen = function SuccessScreen() {
  return (
    <div>
      <div className={css["success-icon"]}>
        <Check size={40} color="white" />
      </div>
      <p className={css["success-title"]}>
        {t("thanks_for_joining")}{" "}
        <span className={css["success-title-highlight"]}>Mountain-Forecast.com!</span>
      </p>
      <p className={css["success-text"]}>{t("you_now_have_access")}</p>
      <div className={css["app-promo-container"]}>
        <div className={css["app-promo-image-container"]}>
          <img src={appMockup} alt="Mountain-Forecast app" className={css["app-promo-image"]} />
        </div>
        <div className={css["app-promo-bg-image-container"]} />
        <div className={css["app-promo-text-container"]}>
          <p className={css["app-promo-title"]}>{t("the_forecast_in_your_pocket")}</p>
          <p className={css["app-promo-text"]}>{t("elevate_your_adventures")}</p>
          <div className={css["app-promo-links"]}>
            <a href="https://apple.co/3Pk0nFt" target="_blank" rel="noopener noreferrer">
              <img src={appStore} alt="App Store" className={css["app-link"]} />
            </a>
            <a href="https://bit.ly/44ChUNA" target="_blank" rel="noopener noreferrer">
              <img src={playStore} alt="Google Play" className={css["app-link"]} />
            </a>
          </div>
        </div>
      </div>
      <button className={css.button} type="submit" onClick={() => window.location.reload()}>
        {t("finish")}
      </button>
    </div>
  )
}
